<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    disable: loadDiscrepenancyReportForm.invalid,
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="clickExit()"
  (emitRightClick)="getReport()"
>
  <form
    class="load-discepenancy-report-container"
    [formGroup]="loadDiscrepenancyReportForm"
  >
    <app-from-to-date
      [fromControl]="'fromDate'"
      [toControl]="'toDate'"
      [formGroupValue]="loadDiscrepenancyReportForm"
    ></app-from-to-date>

    <ion-row>
      <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
        <app-form-select
          formControlName="routes"
          [label]="CONSTS.ROUTE_LABEL"
          [options]="routes"
          [customClass]="'scan-type-dropdown report-select'"
        ></app-form-select>
      </ion-col>
      <ion-col
        size="12"
        size-sm="6"
        size-md="6"
        size-lg="6"
        size-xl="12"
        class="report-format-container"
      >
        <app-report-format
          [radioButtonValue]="
            loadDiscrepenancyReportForm.get('reportFormat')?.value
          "
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"></app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="loadDiscrepancyReport"
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
>
  <ng-container sub-header>
    <table
      aria-hidden="true"
      class="pdf-sub-header-table"
    >
      <tr class="pdf-sub-header-row">
        <td>{{ PDF_REPORT.HEADER.GROUP }} {{ groupCode }}</td>
        <td>
          {{ PDF_REPORT.HEADER.LOOP }}
          {{ loop }}
        </td>
        <td>
          {{ reportDate }}
        </td>
      </tr>
    </table>
  </ng-container>
</app-pdf-report-generator>
